import React from 'react';
import {  Route, Redirect as RouterRedirect } from "react-router-dom";

const ProtectedRoute = ({component: Component, isAuthenticated, ...rest}) => {
  
  return (
    <Route
        {...rest}
        render={props => {
            return isAuthenticated ? (
                <Component {...props } />
            ) : (
                <RouterRedirect
                    to={{
                        pathname: "/login",
                        state: { from: props.location }
                    }}
                />
            )
        }}
    />
  )
};

export default ProtectedRoute;
